// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:  "https://backend-olxs.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-olxs.onrender.com/";
export const weburl = "https://backend-olxs.onrender.com/";
export const testurl = "https://backend-olxs.onrender.com/";

export const shopurl = "https://adminhelply.spacedeco.in/";
export const mainurl = "https://helply.spacedeco.in/";
export const fronturl = "https://helply.spacedeco.in/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;